import styled from 'styled-components';

import { colors, metrics } from 'styles';

type ContainerProps = {
  backgroundColor: string;
};

export const Container = styled.div<ContainerProps>`
  display: none;
  flex-direction: column;
  justify-content: space-between;

  .icon-menu-sandwich {
    cursor: pointer;
  }

  .header-background-search {
    display: none;
    align-items: center;
    flex-direction: column;
    background: linear-gradient(to right, var(--secondary_color), var(--black));
    border-radius: 0 0 0.8rem 0.8rem;
    padding: 0.4rem;
    justify-content: center;
    padding: 1rem 0;
    gap: 0.8rem;

    .icon-search-button {
      background: var(--primary_color);
    }

    .header-search {
      width: 100%;
      max-width: 43rem;
      padding: 0 1rem;

      form {
        width: 100%;
      }
    }

    .home-nav-location {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      cursor: pointer;
      color: var(--primary_color);
      font-size: 0.8rem;
      padding: 0 1rem;
      width: 100%;
      max-width: 43rem;

      > div {
        display: flex;
        flex-direction: row;
        gap: 0.4rem;
      }

      .home-nav-location-info {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.4rem;

        span {
          font-weight: 700;
        }
      }
    }
  }

  .header-top .header-search {
    width: clamp(340px, 33vw, 700px);
  }

  @media (max-width: 768px) {
    .header-top {
      display: grid !important;
      grid-template-columns: 1fr 3fr 1fr;

      .logo {
        justify-self: center;
      }

      .header-nav {
        justify-self: flex-end;
      }

      .header-search {
        display: none;
      }
    }

    .icon-search-button .search-icon {
      content: url('/images/icons/search-white.svg');
      max-width: 1.2rem;
    }
  }

  @media (max-width: 520px) {
    .header-top {
      grid-template-columns: 1.5fr 3fr 1.5fr;

      .header-logo {
        max-width: 8rem !important;
      }
    }
  }

  @media (max-width: 400px) {
    .header-top {
      padding: 1rem !important;

      .icon-menu-sandwich {
        max-width: 0.9rem;
      }

      .header-logo {
        max-width: 6rem !important;
      }

      .header-nav {
        font-size: 0.7rem !important;
      }
    }
  }
`;
